import { signIn, SignInAuthorizationParams } from 'next-auth/react';
import { useCallback } from 'react';

import { buildSignupSuccessCallback } from '../utils/adsConversionTrackingUtils';
import { useMetrics } from './useMetrics';

export type SignUpProps = {
  callbackUrl?: string;
  authParams?: SignInAuthorizationParams;
};

function useSignUp() {
  const metrics = useMetrics();

  const signup = useCallback(
    async (props?: SignUpProps) => {
      // Keep this in mixpanel due to funnel building
      metrics.logEvent('Signup', { sourcePage: window.location.pathname }, true);
      const currentUrl = window.location.href;
      const callbackURI = props?.callbackUrl ? props.callbackUrl : currentUrl || '/';

      // Route through /signup/success for ad-conversion + analytics tracking.
      const callbackUrl = buildSignupSuccessCallback(callbackURI);
      // Send user directly to Azure B2C
      await signIn(
        'azure-ad-b2c-signup',
        {
          callbackUrl: callbackUrl,
        },
        props?.authParams || { ui_locales: 'en', accountType: 'teacher' },
      );
    },
    [metrics],
  );

  return {
    signUp: signup,
  };
}

export default useSignUp;
